import { useRef, useState } from "react";
import { Avatar, Dropdown, Typography, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";

import { NavLink, Link } from "react-router-dom";

import { useSelector } from "react-redux";
const { Text } = Typography;
const items = [
  /*{
    key: "1",
    label: <Link to="/profile">Profil</Link>,
  },
  {
    key: "2",
    label: <Link to="/password">Ganti Password</Link>,
  },
  */
  {
    key: "3",
    label: <Link to="/logout">Logout</Link>,
  },
];

function HeaderUserbox() {
  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);

  const ref = useRef(null);

  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Text style={{ paddingRight: 12 }}>Hi, {currentUser.fullname} </Text>
      <Dropdown menu={{ items }} trigger={["click"]} placement="bottom">
        <Button type="text" style={{ padding: 0 }}>
          <Avatar size="large" icon={<UserOutlined />} />
        </Button>
      </Dropdown>
    </div>
  );
  /*
          <Button type="text" style={{ padding: 0 }}>
          <Avatar size="large" icon={<UserOutlined />} />
        </Button>

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar
          variant="rounded"
          alt={currentUser.name}
          src={currentUser.avatar}
        />

        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser.roles}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          {
            //<Avatar variant="rounded" alt={user.name} src={user.avatar} />
          }
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser.roles}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/akun/profile/details" component={NavLink}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          {/*
          <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem>
          /}
          <ListItem button to="/akun/profile/settings" component={NavLink}>
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary="Account Settings" />
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            fullWidth
            component={NavLink}
            to="/auth/logout"
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
  */
}

export default HeaderUserbox;
